import { lazy } from "react";
import Loadable from "../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../constants/enums";
import { COMM_AUTO_MOBILE_VEHICLE, COMM_AUTO_VEHICLE_ROOT } from "./Commerical.constants";

const CommAutoVehicleRoot = Loadable(
  lazy(() =>
    import("./VehicleRoot").then(({ CommAutoVehicleRoot }) => ({
      default: CommAutoVehicleRoot,
    }))
  )
);
const CommAutomobileVehicle = Loadable(
  lazy(() =>
    import(
      "./CommAutoVehicle/CommAutoVehicle"
    ).then(({ CommAutomobileVehicle }) => ({
      default: CommAutomobileVehicle,
    }))
  )
);

export const VehicleRootRoutes = [
  {
    path: `${COMM_AUTO_VEHICLE_ROOT}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutoVehicleRoot />
      </AuthorizedRoute>
    ),
  },
  {
    path:  `${COMM_AUTO_MOBILE_VEHICLE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileVehicle />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${COMM_AUTO_MOBILE_VEHICLE}/:vehicleNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMERCIAL_AUTO]}>
        <CommAutomobileVehicle />
      </AuthorizedRoute>
    ),
  },
];
